import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';

import { formatBytes } from '../../helpers/Files';

const DownloadInfo = ({
  summary,
  summaryLoading,
  isDownloadRequest,
  isOriginalSizeChecked,
  isSizeChecked,
  isOriginalFormatChecked,
  isFormatChecked,
}) => {
  const intl = useIntl();

  if (summaryLoading) {
    return null;
  }

  let totalFiles = summary.files - summary.links;
  if (!isOriginalSizeChecked && isSizeChecked) {
    totalFiles = summary.resizableFiles;
  }

  let totalSize = 0;
  if (isOriginalSizeChecked || !isSizeChecked) {
    totalSize = summary.size;
  }

  return (
    <div className="download-estimated-size">
      {summary.size === 0 ? (
        intl.formatMessage({ defaultMessage: 'You are not permitted to download these files. Please reach out to your workspace admin.' })
      ) : (
        <>
          {isDownloadRequest ?
            intl.formatMessage({
              defaultMessage: `You are requesting {totalFiles} {totalFiles, plural, one {file} other {files}}
                {totalSize, select, 0 {} other { (~{size})}}`,
            }, { totalFiles, totalSize, size: formatBytes(totalSize, 0) }) :
            intl.formatMessage({
              defaultMessage: `You are downloading {totalFiles} {totalFiles, plural, one {file} other {files}}
                {totalSize, select, 0 {} other { (~{size})}}`,
            }, { totalFiles, totalSize, size: formatBytes(totalSize, 0) })}
        </>
      )}
      {(isSizeChecked || isFormatChecked) && (
        <HelpIcon permanent>
          {(isOriginalSizeChecked || isOriginalFormatChecked) ? (
            intl.formatMessage({
              defaultMessage: 'Total download size is an estimate - we are not able to predict the size of resized or converted images',
            })
          ) : (
            intl.formatMessage({ defaultMessage: 'We are not able to predict the size of resized or converted images' })
          )}
        </HelpIcon>
      )}
    </div>
  );
};

DownloadInfo.propTypes = {
  summary: PropTypes.object.isRequired,
  summaryLoading: PropTypes.bool.isRequired,
  isDownloadRequest: PropTypes.bool.isRequired,
  isOriginalSizeChecked: PropTypes.bool.isRequired,
  isSizeChecked: PropTypes.bool.isRequired,
  isOriginalFormatChecked: PropTypes.bool.isRequired,
  isFormatChecked: PropTypes.bool.isRequired,
};

export default DownloadInfo;
